import React from 'react';
import {
  Box, Typography, Container, Paper, Button,
} from '@mui/material';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { useTranslation } from 'react-i18next';
import explanationsImage from '../files/images/explanations-1.avif';

function PhotoGallery() {
  const { t } = useTranslation();

  const handleOpenGallery = () => {
    // Replace this URL with the actual gallery website URL
    window.open('https://my.wedibox.com/rec0K69XdKRxhX5Q', '_blank');
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '80vh',
      backgroundColor: 'background.default',
      py: 8,
    }}
    >
      <Container maxWidth="lg">
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          py: 4,
        }}
        >
          <Typography
            variant="h4"
            sx={{
              color: 'terracota.main',
              mb: 3,
              fontWeight: 'medium',
              textAlign: 'center',
            }}
          >
            {t('gallery.title')}
          </Typography>

          {/* <Typography
            variant="h6"
            sx={{
              color: 'text.primary',
              mb: 6,
              lineHeight: 1.6,
              textAlign: 'center',
              maxWidth: 600,
            }}
          >
            {t('gallery.subtitle')}
          </Typography> */}

          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              mb: 4,
              lineHeight: 1.8,
              maxWidth: 800,
              textAlign: 'center',
            }}
          >
            {t('gallery.description')}
          </Typography>

          {/* Instructions with image */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 2,
              mb: 4,
              maxWidth: 1200,
            }}
          >
            <Typography
              variant="h7"
              sx={{
                color: 'terracota.main',
                textAlign: 'center',
                fontWeight: 'medium',
              }}
            >
              {t('gallery.instructions.step1')}
            </Typography>
            <Typography
              variant="h7"
              sx={{
                color: 'terracota.main',
                textAlign: 'center',
                fontWeight: 'medium',
                mb: 2,
              }}
            >
              {t('gallery.instructions.step2')}
            </Typography>
            <img
              src={explanationsImage}
              alt="Gallery instructions"
              style={{
                width: '100%',
                maxWidth: 1200,
                height: 'auto',
                borderRadius: 8,
              }}
            />
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={handleOpenGallery}
            sx={{
              backgroundColor: 'terracota.main',
              color: 'white',
              px: 6,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 'medium',
              '&:hover': {
                backgroundColor: 'terracota.dark',
              },
              textTransform: 'none',
            }}
            startIcon={<PhotoLibraryIcon />}
          >
            {t('gallery.open_button')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default PhotoGallery;
